/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Currency } from './Currency';
import { TaxBehavior } from './TaxBehavior';
const BaseAccessPlanDataParser = /* #__PURE__ */ parsers.object([
    ['currency', Currency],
    ['amount', parsers.decimal],
    ['refundPeriod', parsers.duration, 'refund_period'],
    ['taxBehavior', TaxBehavior, 'tax_behavior'],
    ['duration', parsers.duration],
]);
export class BaseAccessPlanData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseAccessPlanDataParser.decode(input).map(res => new BaseAccessPlanData(res));
    }
    static unsafeDecode(input) {
        return BaseAccessPlanData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseAccessPlanDataParser.encode(data);
    }
    static schema() {
        return BaseAccessPlanDataParser.schema();
    }
}
